import semver from 'semver';

/** Only versions before v4 have the vegetation inputs and outputs pages. */
export function hasPreV4Pages(version: string | undefined): boolean {
  return Boolean(version && semver.lt(version, '4.0.0'));
}
